import QRCode from 'qrcode'
import { RenderPDF } from 'templates/template'
import { pdf } from '@react-pdf/renderer'
import download from 'downloadjs'
import Certificate from 'interfaces/Certificate'
import TemplateService from 'services/TemplateService'
import FileService from 'services/FileService'

/** PNG data URL estable para react-pdf (sin depender del DOM/canvas oculto). */
const buildQrDataUrl = async (text: string): Promise<string> => {
  const value = text?.trim()
  if (!value) {
    throw new Error('La URL del código QR está vacía.')
  }
  return QRCode.toDataURL(value, {
    errorCorrectionLevel: 'M',
    margin: 1,
    width: 280,
    color: { dark: '#000000', light: '#ffffff' },
  })
}

export const downloadPDF = async (certificate: Certificate) => {
  try {
    const template = await TemplateService.getTemplate(certificate.templateId)

    if (!template?.imagePath) {
      alert('La plantilla no tiene imagen asociada.')
      return
    }

    const imageDataUrl = await FileService.fetchImageDataUrl(template.imagePath)

    let qrCodeDataUri: string | null = null
    if (certificate.hasQR && certificate.qrCode?.trim()) {
      qrCodeDataUri = await buildQrDataUrl(certificate.qrCode)
    }

    const blob = await pdf(
      RenderPDF(qrCodeDataUri, certificate, imageDataUrl)
    ).toBlob()
    download(blob, 'certificado.pdf')
  } catch (err) {
    console.error(err)
    const message =
      err instanceof Error ? err.message : 'No se pudo generar la vista previa.'
    alert(message)
  }
}
